<template>
    <p class="text-sm leading-5">
        Showing
        <span class="font-semibold">{{ meta.from }}</span>
        to
        <span class="font-semibold">{{ meta.to }}</span>
        of
        <span class="font-semibold">{{ meta.total }}</span>
        results
    </p>
</template>

<script>

export default {
    props: {
        meta: {
            type: Object,
            required: true
        }
    },
};

</script>
